import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import {alpha} from "@mui/material/styles";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import {Shell} from "../../common/shell/shell.page";

const faqs = [
  {
    q: "Como altero o plano da minha assinatura?",
    a: "Acesse Administração > Meu Plano. Você pode visualizar os planos disponíveis e solicitar a mudança diretamente pela tela.",
  },
  {
    q: "Perdi o acesso ao sistema. O que fazer?",
    a: "Use a opção 'Esqueci minha senha' na tela de login. Se o problema persistir, entre em contato pelo WhatsApp ou e-mail para que possamos verificar sua conta.",
  },
  {
    q: "Como adiciono um novo usuário ao sistema?",
    a: "Acesse Administração > Usuários e clique em 'Convidar usuário'. Informe o e-mail e as permissões desejadas.",
  },
  {
    q: "Meus dados estão seguros?",
    a: "Sim. O Symplou utiliza infraestrutura segura em nuvem com criptografia em trânsito e em repouso. Seus dados são isolados por empresa e nunca compartilhados com terceiros.",
  },
  {
    q: "O sistema funciona offline?",
    a: "Atualmente o Symplou requer conexão com a internet para funcionar. Estamos trabalhando em um modo offline para futuras versões.",
  },
  {
    q: "Como cancelo minha assinatura?",
    a: "Entre em contato com nosso suporte pelo WhatsApp ou e-mail. Nossa equipe processará o cancelamento e confirmará por e-mail.",
  },
];

export const SupportContactPage = () => {
  return (
    <Shell title="Atendimento">
      <Box sx={{maxWidth: 860, mx: "auto"}}>
        <Box
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            mb: 4,
            position: "relative",
            background:
              "linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)",
            p: {xs: 3, sm: 5},
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundImage:
                "radial-gradient(circle at 20% 50%, rgba(99,102,241,0.18) 0%, transparent 60%), radial-gradient(circle at 80% 20%, rgba(45,212,191,0.12) 0%, transparent 50%)",
              pointerEvents: "none",
            }}
          />
          <Stack
            direction={{xs: "column", sm: "row"}}
            alignItems={{sm: "center"}}
            spacing={3}
            sx={{position: "relative"}}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: 3,
                background:
                  "linear-gradient(135deg, rgba(99,102,241,0.6) 0%, rgba(45,212,191,0.5) 100%)",
                border: "1px solid rgba(255,255,255,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                backdropFilter: "blur(8px)",
              }}
            >
              <HeadsetMicIcon sx={{fontSize: 36, color: "#fff"}} />
            </Box>
            <Box>
              <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 0.5}}>
                <Typography
                  variant="h4"
                  fontWeight={800}
                  sx={{color: "#f8fafc", letterSpacing: "-0.03em"}}
                >
                  Atendimento Symplou
                </Typography>
                <Chip
                  icon={<AutoAwesomeIcon sx={{fontSize: "14px !important"}} />}
                  label="Premium"
                  size="small"
                  sx={{
                    background:
                      "linear-gradient(90deg, rgba(99,102,241,0.7), rgba(45,212,191,0.6))",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 11,
                    border: "1px solid rgba(255,255,255,0.2)",
                    "& .MuiChip-icon": {color: "#fff"},
                  }}
                />
              </Stack>
              <Typography
                variant="body1"
                sx={{color: "rgba(248,250,252,0.7)", lineHeight: 1.6}}
              >
                Nossa equipe está pronta para ajudar. Escolha o canal de preferência
                e entraremos em contato o mais rápido possível.
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Stack
          direction={{xs: "column", sm: "row"}}
          spacing={2}
          sx={{mb: 4}}
        >
          <Card
            elevation={0}
            sx={{
              flex: 1,
              border: "1px solid",
              borderColor: alpha("#25d366", 0.3),
              borderRadius: 3,
              background: (t) =>
                alpha(t.palette.mode === "dark" ? "#25d366" : "#25d366", 0.04),
              transition: "all 0.2s ease",
              "&:hover": {
                borderColor: alpha("#25d366", 0.6),
                transform: "translateY(-2px)",
                boxShadow: `0 8px 24px ${alpha("#25d366", 0.12)}`,
              },
            }}
          >
            <CardContent sx={{p: {xs: 2.5, sm: 3}}}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  bgcolor: alpha("#25d366", 0.12),
                  color: "#25d366",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <WhatsAppIcon />
              </Box>
              <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                WhatsApp
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{mb: 2.5, lineHeight: 1.6}}
              >
                Atendimento rápido pelo WhatsApp. Respostas em até 1 hora durante
                o horário comercial.
              </Typography>
              <Typography variant="caption" sx={{display: "block", mb: 2, fontWeight: 700}}>
                WhatsApp: 44 98846-5173
              </Typography>
              <Stack spacing={1} sx={{mb: 2.5}}>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <CheckCircleOutlineIcon
                    sx={{fontSize: 15, color: "#25d366"}}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Suporte técnico e dúvidas do sistema
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <CheckCircleOutlineIcon
                    sx={{fontSize: 15, color: "#25d366"}}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Auxílio com configurações e módulos
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <CheckCircleOutlineIcon
                    sx={{fontSize: 15, color: "#25d366"}}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Problemas de acesso e conta
                  </Typography>
                </Stack>
              </Stack>
              <Button
                variant="contained"
                fullWidth
                startIcon={<WhatsAppIcon />}
                href="https://wa.me/5544988465173"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  bgcolor: "#25d366",
                  color: "#fff",
                  fontWeight: 700,
                  borderRadius: 2,
                  textTransform: "none",
                  "&:hover": {bgcolor: "#1fba58"},
                }}
              >
                Abrir WhatsApp
              </Button>
            </CardContent>
          </Card>

          <Card
            elevation={0}
            sx={{
              flex: 1,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 3,
              transition: "all 0.2s ease",
              "&:hover": {
                borderColor: "primary.main",
                transform: "translateY(-2px)",
                boxShadow: (t) =>
                  `0 8px 24px ${alpha(t.palette.primary.main, 0.1)}`,
              },
            }}
          >
            <CardContent sx={{p: {xs: 2.5, sm: 3}}}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  bgcolor: "primary.main",
                  color: "primary.contrastText",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <EmailOutlinedIcon />
              </Box>
              <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                E-mail
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{mb: 2.5, lineHeight: 1.6}}
              >
                Envie uma mensagem detalhada e nossa equipe responderá em até 24
                horas úteis.
              </Typography>
              <Stack spacing={1} sx={{mb: 2.5}}>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <CheckCircleOutlineIcon
                    sx={{fontSize: 15, color: "primary.main"}}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Solicitações de funcionalidades
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <CheckCircleOutlineIcon
                    sx={{fontSize: 15, color: "primary.main"}}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Cancelamento e alterações de plano
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <CheckCircleOutlineIcon
                    sx={{fontSize: 15, color: "primary.main"}}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Questões financeiras e faturamento
                  </Typography>
                </Stack>
              </Stack>
              <Button
                variant="outlined"
                fullWidth
                startIcon={<EmailOutlinedIcon />}
                href="mailto:suporte@symplou.com.br"
                sx={{
                  fontWeight: 700,
                  borderRadius: 2,
                  textTransform: "none",
                }}
              >
                Enviar e-mail
              </Button>
            </CardContent>
          </Card>
        </Stack>

        <Card
          elevation={0}
          sx={{
            border: 1,
            borderColor: "divider",
            borderRadius: 3,
            mb: 4,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: {xs: 2.5, sm: 3},
              py: 2,
              bgcolor: (t) => alpha(t.palette.warning.main, 0.06),
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <AccessTimeIcon sx={{color: "warning.main", fontSize: 20}} />
              <Typography variant="subtitle2" fontWeight={700}>
                Horário de atendimento
              </Typography>
            </Stack>
          </Box>
          <CardContent sx={{p: {xs: 2.5, sm: 3}}}>
            <Stack
              direction={{xs: "column", sm: "row"}}
              spacing={{xs: 2, sm: 4}}
            >
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={600}
                  sx={{textTransform: "uppercase", letterSpacing: "0.08em"}}
                >
                  Segunda a Sexta
                </Typography>
                <Typography variant="body1" fontWeight={700} sx={{mt: 0.25}}>
                  08:00 – 18:00
                </Typography>
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                sx={{display: {xs: "none", sm: "block"}}}
              />
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={600}
                  sx={{textTransform: "uppercase", letterSpacing: "0.08em"}}
                >
                  Sábado
                </Typography>
                <Typography variant="body1" fontWeight={700} sx={{mt: 0.25}}>
                  09:00 – 13:00
                </Typography>
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                sx={{display: {xs: "none", sm: "block"}}}
              />
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={600}
                  sx={{textTransform: "uppercase", letterSpacing: "0.08em"}}
                >
                  Domingo e Feriados
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight={700}
                  color="text.secondary"
                  sx={{mt: 0.25}}
                >
                  Fechado
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        <Box sx={{mb: 2}}>
          <Stack direction="row" alignItems="center" spacing={1.5} sx={{mb: 3}}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                bgcolor: (t) => alpha(t.palette.primary.main, 0.1),
                color: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <HelpOutlineIcon fontSize="small" />
            </Box>
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                Perguntas frequentes
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Respostas rápidas para as dúvidas mais comuns.
              </Typography>
            </Box>
          </Stack>

          <Stack spacing={1.5}>
            {faqs.map((faq, i) => (
              <Card
                key={i}
                elevation={0}
                sx={{
                  border: 1,
                  borderColor: "divider",
                  borderRadius: 2.5,
                  transition: "border-color 0.15s",
                  "&:hover": {borderColor: "primary.main"},
                }}
              >
                <CardContent sx={{p: {xs: 2, sm: 2.5}, "&:last-child": {pb: {xs: 2, sm: 2.5}}}}>
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    gutterBottom
                    sx={{color: "text.primary"}}
                  >
                    {faq.q}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{lineHeight: 1.65}}
                  >
                    {faq.a}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Box>
      </Box>
    </Shell>
  );
};
